/**
 * Radiology window/level presets.
 *
 * Used by the W/L preset bar and by the hanging-protocol JSON loader
 * when a rule matches. Indexed by DICOM Modality (0008,0060).
 */

export interface WLPreset {
  name: string;
  wc: number;
  ww: number;
}

/**
 * Radiological presets — HU for CT, raw pixel values elsewhere. Names
 * follow common radiology practice + Syngo / Centricity defaults.
 */
export const PRESETS_BY_MODALITY: Record<string, WLPreset[]> = {
  CT: [
    { name: "Abdomen",     wc:   60, ww: 400 },
    { name: "Lung",        wc: -600, ww: 1500 },
    { name: "Bone",        wc:  400, ww: 1800 },
    { name: "Brain",       wc:   40, ww:  80 },
    { name: "Mediastinum", wc:   50, ww: 350 },
    { name: "Soft tissue", wc:   40, ww: 400 },
    { name: "Angio",       wc:  200, ww: 600 },
  ],
  MR: [
    { name: "Default",     wc: 400, ww: 1000 },
    { name: "FLAIR",       wc: 600, ww: 1200 },
    { name: "T1",          wc: 500, ww: 1000 },
    { name: "T2",          wc: 800, ww: 1600 },
  ],
  CR: [
    { name: "Soft tissue", wc: 2048, ww: 4096 },
    { name: "Bone",        wc: 1536, ww: 2048 },
  ],
  DX: [
    { name: "Soft tissue", wc: 2048, ww: 4096 },
    { name: "Bone",        wc: 1536, ww: 2048 },
  ],
  MG: [
    { name: "Standard",    wc: 2048, ww: 4096 },
    { name: "Dense",       wc: 2500, ww: 3500 },
  ],
  US: [
    { name: "Default",     wc:  128, ww:  256 },
  ],
  NM: [
    { name: "Default",     wc:  128, ww:  256 },
  ],
  PT: [
    { name: "SUV 0–5",     wc:   2.5, ww: 5 },
    { name: "SUV 0–15",    wc:   7.5, ww: 15 },
  ],
  XA: [
    { name: "Default",     wc:  128, ww:  256 },
  ],
  ES: [
    { name: "Default",     wc:  128, ww:  256 },
  ],
};

export function presetsFor(modality: string | undefined | null): WLPreset[] {
  if (!modality) return PRESETS_BY_MODALITY["CT"];
  const up = modality.toUpperCase();
  return PRESETS_BY_MODALITY[up] ?? PRESETS_BY_MODALITY["CT"];
}
